<div class="lb-jackpot-header">
  <img class="lb-jackpot-header--logo" [src]="headerImage" alt="Jackpots logo" />
  <span class="line" role="decorative"></span>
</div>
